var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid",
    class: [_vm.payloadInterface.primarySlice.background_color ? 'layout-with-background' : 'layout-without-background'],
    style: {
      backgroundColor: _vm.payloadInterface.primarySlice.background_color
    }
  }, [_c('div', {
    staticClass: "text-center my-4 titles"
  }, [_vm.payloadInterface.primarySlice.title.length ? _c('RegularTitle', {
    staticClass: "mb-2 title",
    attrs: {
      "text": _vm.payloadInterface.primarySlice.title[0].text,
      "level": _vm.payloadInterface.primarySlice.title[0].type
    }
  }) : _vm._e(), _vm._v(" "), _vm.payloadInterface.primarySlice.paragraph.length > 0 ? _c('SimpleParagraph', {
    staticClass: "mb-2 paragraph",
    attrs: {
      "paragraph": _vm.payloadInterface.primarySlice.paragraph
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "px-0 col-lg-12 col-md-11 mx-auto"
  }, [_c('div', {
    ref: "slider",
    staticClass: "slider position-relative my-lg-4"
  }, _vm._l(_vm.payloadInterface.items, function (item, index) {
    return _c('div', {
      key: "".concat(index, "-").concat(item.title[0].text),
      ref: "slide",
      refInFor: true,
      staticClass: "slide"
    }, [_c('Slide', {
      attrs: {
        "avatar": item.avatar,
        "avatar-title": item.avatarTitle,
        "avatar-subtitle": item.avatarSubtitle,
        "image": item.image,
        "tag1": item.tag1,
        "tag2": item.tag2,
        "title": item.title,
        "description": item.description,
        "cta": item.cta,
        "cta-theme": item.ctaTheme,
        "link": item.link,
        "image-before": item.imageBefore,
        "image-after": item.imageAfter,
        "label-image-before": _vm.labelImageBefore,
        "label-image-after": _vm.labelImageAfter,
        "tracking": item.tracking
      }
    })], 1);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "slider-actions d-none d-md-block"
  }, [_c('button', {
    staticClass: "btn-link prev rounded-circle",
    class: {
      hide: !_vm.isLeftButtonVisible
    },
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('previous')
    },
    on: {
      "click": _vm.onLeftClick
    }
  }, [_c('mdm-icon', {
    staticClass: "fill-white",
    attrs: {
      "name": "chevron-left",
      "size": "32"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn-link next rounded-circle",
    class: {
      hide: !_vm.isRightButtonVisible
    },
    attrs: {
      "type": "button",
      "aria-label": _vm.$t('next')
    },
    on: {
      "click": _vm.onRightClick
    }
  }, [_c('mdm-icon', {
    staticClass: "fill-white",
    attrs: {
      "name": "chevron-left",
      "size": "32"
    }
  })], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };